import { InternalTemplateDetails } from "features/internal/template/InternalTemplateDetails";
import { useInternalEventTemplateVersionRetrieveSuspense } from "gen/endpoints/internal/internal";
import { useTranslation } from "react-i18next";
import PageBody from "shared/components/layout/PageBody";
import PageContent from "shared/components/layout/PageContent";
import { PageHeader } from "shared/components/layout/PageHeader";
import { useRequiredStringParams } from "shared/hooks/useRequiredStringParams";
import { rootRoute } from "shared/navigation/Routes";

export const InternalTemplatePage: React.FC = () => {
  const { t } = useTranslation(["common", "internal"]);
  const { templateVersionId } = useRequiredStringParams();

  const { data: templateData } =
    useInternalEventTemplateVersionRetrieveSuspense(templateVersionId);

  return (
    <PageContent isFullHeight={true}>
      <PageHeader
        title={templateData.name}
        helperText={templateData.description}
        backButton={{
          title: t("common:back"),
          path: rootRoute({}).internal({}).shadow({}).templateTab({}).$,
        }}
      />
      <PageBody>
        <InternalTemplateDetails
          templateVersionId={templateVersionId}
          includeDraftEvents={true}
        />
      </PageBody>
    </PageContent>
  );
};
